import React, { useEffect, useState } from 'react'
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { getThumbnailUrlFromEmbedLink } from '../../../helper/getThumbnailUrlFromEmbedLink';
import { aedLogoStyle, getDirhamImage, iconContainer, pageTitle, showIconsContainer, termsTitle, whiteCard } from '../../../common/cssclasses';
import { useTranslate } from '../../../components/TranslationText';
import NewActionButton from '../../../components/ActionButtons/NewActionButton';
import { formatDate } from '../../../helper/formatDate';
import { useLocation, useNavigate } from 'react-router';
import { getSemenById } from '../Api/semenMarketApi';

export default function SemenDetailsPage() {
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.has("semenId") ? searchParams.get("semenId") : null;
    const currentlang = localStorage.getItem('eahsLang') ?? 'en';
    const renderVideo = (item) => {
        return (
            <div className="">
                {item.video === true ? (
                    <iframe
                        width="100%"
                        src={item.embedUrl}
                        frameBorder="0"
                        allowFullScreen={false}
                        style={{ aspectRatio: '16/9' }}
                        title="ex"
                    />
                ) : (
                    <React.Fragment></React.Fragment>
                )}
            </div>
        );
    };


    const initsemen = {
        images: ['https://previews.123rf.com/images/siberian64/siberian642003/siberian64200300003/143675213-horses-in-the-meadow-livestock-in-the-countryside-aspect-ratio-16-9.jpg'],
        videos: ['https://www.youtube.com/embed/PXPxK-a7Lt0'],
        horseName: 'A.S. AL DHAHAB',
        gender: 'STALLION',
        birthDate: formatDate(new Date()),
        horseCategory: 'Show Horse',
        color: 'white',
        owner: 'SUMAYA HUSSAIN MOHAMMAD ABDULQADER ABBAS',
        address: 'Dubai, UAE',
        origin: 'Syria',
        ownerMail: 'summaya@mail.com',
        ownerPhone: '971504230624',
        price: 500,
        regNr: 123,
        sire: 'Sire Name',
        dam: 'Dam Name',

    }

    const [semen, setSemen] = useState(initsemen);

    function fetchSemen() {
        getSemenById(id).then(res => setSemen(res));
    }

    const gallery = [...semen?.videos.map((item) => ({ thumbnail: getThumbnailUrlFromEmbedLink(item), renderItem: renderVideo.bind(this), video: true, embedUrl: item })), ...semen?.images.map((item) => ({ thumbnail: item, original: item }))]

    useEffect(() => {
        fetchSemen()
    }, [])


    return (
        <div className='row'>
            <h2 className={termsTitle + " d-flex align-items-center flex-wrap mb-main"}>
                {!!semen?.regNr && semen.regNr + " - "} {semen?.horseName}
                <div className='ms-auto d-flex align-items-center flex-wrap'>
                    <NewActionButton
                        classNames='btn-danger w-unset'
                        text={translate('web.buyNow', 'Buy Now')}
                        key={'buyNow'}
                        onClick={(e) => { navigate(`/semenCheckout?semenMarketId=${id}`) }}
                    />

                </div>
            </h2>
            <div className={showIconsContainer}>
                {detailsRow('fa fa-user', 'web.owner', semen?.owner, 'w-unset')}

                <div className={iconContainer}>
                    <img src={getDirhamImage(currentlang)} alt='AED' style={aedLogoStyle} />
                    <span className='fw-bold'>{`${translate("web.price", "Price")}`} {semen?.price?.toLocaleString("en-US")} {translate('web.aed', 'AED')}</span>
                </div>



            </div>
            <div className='col-md-8 col-12'>
                <style>
                    {`.image-gallery{border-radius:15px;overflow:hidden; }`}
                </style>
                <div className={whiteCard}>
                    <ImageGallery
                        items={gallery}
                        showPlayButton={false}
                        showIndex={true}
                        showFullscreenButton={true}

                    />
                </div>
            </div>
            <div className='col-md-4 col-12'>
                <div className={whiteCard}>
                    {rightDetails('fa fa-calendar', 'web.birthDate', semen?.birthDate)}
                    {rightDetails('fa fa-palette', 'web.color', semen?.color)}
                    {rightDetails('fa fa-earth-americas', 'web.origin', semen?.origin)}
                    {rightDetails('fa fa-tags', 'web.owner', semen?.owner)}
                    {rightDetails('fa fa-envelope', 'web.email', semen?.ownerMail)}
                    {rightDetails('fa fa-phone', 'web.phone', semen?.ownerPhone)}
                    {rightDetails('fa fa-location-dot', 'web.address', semen?.address)}
                    <div className='row'>
                        <div className='ms-auto w-unset d-flex align-items-center flex-wrap'>
                            <NewActionButton
                                classNames='btn-outline-danger w-unset'
                                text={translate('web.StudBookDetails', 'StudBook Details')}
                                onClick={(e) => { navigate(`/horsedetails?horseId=${semen?.stallionId}`) }}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
    function detailsRow(icon = '', key = "", value = "", classNames = "") {
        return <div className={iconContainer + ' ' + classNames}>
            <i className={`${icon} C89C66`} />
            <span className='fw-bold' >{translate(key, key)} {!!value
                ? value
                : translate("web.unknown", "unknown")} </span>
        </div>;
    }
    function rightDetails(icon = '', key = "", value = "") {
        return <div className='col-sm-12 col-12 mb-2'>
            <span className="fw-bold">
                <i className={`${icon} C89C66 me-2`} />
                {translate(key, key) + ":"}
            </span>
            <span className="fw-bold ms-2">
                {!!value
                    ? value : '-'}
                {/* // : translate("web.unknown", "unknown")} */}
            </span>
        </div>;
    }
}
